module.exports = __webpack_public_path__ + "img/vuejs.cd7d7f73.png";